var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "project-date",
    clipPath: "url(#clip0_1170_91035)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.79688 9.6C4.57021 9.6 4.38008 9.5232 4.22648 9.3696C4.07288 9.216 3.99634 9.02613 3.99688 8.8C3.99688 8.57333 4.07368 8.3832 4.22728 8.2296C4.38088 8.076 4.57074 7.99947 4.79688 8C5.02354 8 5.21368 8.0768 5.36728 8.2304C5.52088 8.384 5.59741 8.57387 5.59688 8.8C5.59688 9.02667 5.52008 9.2168 5.36648 9.3704C5.21288 9.524 5.02301 9.60053 4.79688 9.6ZM7.99688 9.6C7.77021 9.6 7.58008 9.5232 7.42648 9.3696C7.27288 9.216 7.19634 9.02613 7.19688 8.8C7.19688 8.57333 7.27368 8.3832 7.42728 8.2296C7.58088 8.076 7.77074 7.99947 7.99688 8C8.22354 8 8.41368 8.0768 8.56728 8.2304C8.72088 8.384 8.79741 8.57387 8.79688 8.8C8.79688 9.02667 8.72008 9.2168 8.56648 9.3704C8.41288 9.524 8.22301 9.60053 7.99688 9.6ZM11.1969 9.6C10.9702 9.6 10.7801 9.5232 10.6265 9.3696C10.4729 9.216 10.3963 9.02613 10.3969 8.8C10.3969 8.57333 10.4737 8.3832 10.6273 8.2296C10.7809 8.076 10.9707 7.99947 11.1969 8C11.4235 8 11.6137 8.0768 11.7673 8.2304C11.9209 8.384 11.9974 8.57387 11.9969 8.8C11.9969 9.02667 11.9201 9.2168 11.7665 9.3704C11.6129 9.524 11.423 9.60053 11.1969 9.6ZM2.39688 16C1.95688 16 1.58008 15.8432 1.26648 15.5296C0.952876 15.216 0.796343 14.8395 0.796876 14.4V3.2C0.796876 2.76 0.953676 2.3832 1.26728 2.0696C1.58088 1.756 1.95741 1.59947 2.39688 1.6H3.19688V0H4.79688V1.6H11.1969V0H12.7969V1.6H13.5969C14.0369 1.6 14.4137 1.7568 14.7273 2.0704C15.0409 2.384 15.1974 2.76053 15.1969 3.2V14.4C15.1969 14.84 15.0401 15.2168 14.7265 15.5304C14.4129 15.844 14.0363 16.0005 13.5969 16H2.39688ZM2.39688 14.4H13.5969V6.4H2.39688V14.4Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1170_91035"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/Calendar.c538796e403aa78d4c936fd9f19502e8.svg";
export { ForwardRef as ReactComponent };